export class EnumUtil {

  // static stringIsNumber = value => isNaN(Number(value)) === false;

  static toArray(_enum): {label: string, value: any}[] {
    return Object.keys(_enum)
        // .filter(EnumUtil.stringIsNumber)
        .map(key => {
          return {
            label: _enum[key],
            value: key
          }
        });
  }

}